import { LOCALE } from '~/translations/translation.types';
import { TranslationService } from '~/translations/translations.service';

export default () => {
  return TranslationService.getTranslations(LOCALE.RU);
};
